import React, { Component } from "react";

import Button from "@mui/material/Button";

import UserSubject from "../../../../store/modquiz/subjects/user_subject";
import { ISubjectParent, SubjectListDetail } from "./Detail";

import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';


import "./style.css";

interface SubjectListProps {
    subjects: Map<string, UserSubject>;
    markComplete: Function;
    showSubject: Function;
    quiz: Function;
}

function TabPanel(props: any) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }
  
function SubjectList({ markComplete, subjects, showSubject, quiz }: SubjectListProps) {
    const subjectArray: ISubjectParent[] = [...subjects.values()];
    return (
        <SubjectListArray
            markComplete={markComplete}
            subjects={subjectArray}
            showSubject={showSubject}
            quiz={quiz}
        />
    );
}

type SubjectListArrayProps = {
    subjects: ISubjectParent[];
    markComplete: Function;
    quiz: Function;
    showSubject: Function;
};

function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
}

function SubjectListArray({
    subjects,
    markComplete,
    showSubject,
    quiz
}: SubjectListArrayProps) {
    if (!subjects) {
        return (
            <p>
                Choose 'Search Subjects to Add' to search our database of
                existing user-created subjects, or click 'Create New Subject' to
                add your own.
            </p>
        );
    }

    console.log("Subjects in SubjectListArray");
    console.log(subjects);

    const incompleteSubjects = subjects.filter(
        (subject: ISubjectParent) => subject.enabled
    );
    const completeSubjects = subjects.filter(
        (subject: ISubjectParent) => !subject.enabled
    );

    const [value, setValue] = React.useState(0);

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
      setValue(newValue);
    };
  
    return (
        <div className="subject-index-list">
            <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
              <Tab label="Active" {...a11yProps(0)} />
              <Tab label="Completed" {...a11yProps(1)} />
            </Tabs>

            <TabPanel value={value} index={0}>
                <SubjectListDetail
                    subjectList={incompleteSubjects}
                    showSubject={showSubject}
                    markComplete={markComplete}
                />
            </TabPanel>
      <TabPanel value={value} index={1}>
            <SubjectListDetail
                subjectList={completeSubjects}
                showSubject={showSubject}
                markComplete={markComplete}
            />
          </TabPanel>

            {/* <SubjectListDetail
                title="Active Subjects"
                subjectList={incompleteSubjects}
                showSubject={showSubject}
                markComplete={markComplete}
            />
            <SubjectListDetail
                title="Complete Subjects"
                subjectList={completeSubjects}
                showSubject={showSubject}
                markComplete={markComplete}
            /> */}
        </div>
    );
}

export { SubjectList, SubjectListArray };
